import React from "react";
import { Link } from 'react-router-dom'; // Assuming you are using react-router

export default function RelatedJobComponent(props) {
  const { path } = props;
  const {
    id,
    company_name,
    job_title,
    // job_details, // Commented out in your original code
    profile_image,
    job_ctc,
    locations,
    full_time,
    part_time,
    wfh,
    intership,
    experience,
    identity_labels,
    icon_title
  } = props.item;

  return (
    <div className="single-rated">
      <div className="d-flex justify-content-center">
        {profile_image && (
          <img
            className="img-fluid"
            src={encodeURI(profile_image)}
            alt={job_title ?? "NA"}
            title={icon_title}
            style={{ height: "100px" }}
          />
        )}
      </div>

      <Link to={`/job-detail/${id}`}>
        <h4>{job_title ?? "NA"}</h4>
      </Link>
      
      <h6>{company_name ?? "NA"}</h6>

      {/* FIX: Wrapped bare text and conditionals safely in span tags */}
      <h5>
        <span>Job Nature: </span>
        {full_time === "Yes" && <span>Full-Time, </span>}
        {part_time === "Yes" && <span>Part-Time, </span>}
        {wfh === "Yes" && <span>Work From Home, </span>}
        {intership === "Yes" && <span>Internship</span>}
      </h5>

      {/* FIX: Wrapped the string variables in spans */}
      <p className="address">
        <span className="lnr lnr-map" /> <span>{locations ?? "NA"}</span>
      </p>
      
      <p className="address">
        <span className="lnr lnr-calendar-full" /> <span>{experience ?? "NA"}</span>
      </p>

      <Link to={`/job-detail/${id}`} className="btns text-uppercase">
        <span>Apply job</span>
      </Link>
    </div>
  );
}
